export const PERMISSION_CONSTANTS = {
    AIR: 'Air.Air',
    IMPERSONATION: 'Auth.Impersonation',
    CONNECTED_APP:'ConnectedApp.ConnectedApp',
    DashboardLastFiveBalance:'Dashboard.LastFiveBalance',
    USER: 'User.User',
    DashboardSalesQuantity:'Dashboard.SalesQuantity',
    DashboardSalesAmount:'Dashboard.SalesAmount'
};
export const PERMISSION_DEPENDENCY_TYPE = {
    REQUIRED:'Required',
    SUPPORTING: 'Supporting',
    OPTIONAL:'Optional'
}